export default __webpack_public_path__ + "static/media/chill-3x.54353605.png";